const name = 'ScreenInAspect'
const SCREEN_IN_ACTION = 'screenIn'

const defaultModel = {}

function screenInHandler(entry, compId) {
    if (entry.visible) {
        // trigger animation
        this.trigger([{
            compId,
            action: SCREEN_IN_ACTION
        }])
    }
}

function getAnimationThreshold(animationManager, animationDefs, id) {
    const animationName = animationDefs[id][SCREEN_IN_ACTION][0].name
    return animationManager.animationProperties[animationName].viewportThreshold
}

const functionLibrary = {
    updateViewportRegistry: ({next, previous}, animationDefs, animationManager, viewportRegistry) => {
        if (!animationManager) {
            return
        }

        // add new and register
        Object.keys(next).forEach(id => {
            const threshold = getAnimationThreshold(animationManager, animationDefs, id)

            animationManager.initComponentAction(id, SCREEN_IN_ACTION)

            // register
            viewportRegistry.register(name, id, {
                handler: screenInHandler.bind(animationManager),
                threshold
            })
        })

        // delete old and unregister
        Object.keys(previous).forEach(id => {
            // unregister
            // we always get every new id in `next` ALSO in `previous` since it's the old ref, so check here
            if (!next[id] && animationDefs[id]) {
                const threshold = getAnimationThreshold(animationManager, animationDefs, id)

                viewportRegistry.unregister(name, id, threshold)
            }
        })
    }
}

export {
    name,
    defaultModel,
    SCREEN_IN_ACTION,
    functionLibrary
}
